// extracted by mini-css-extract-plugin
module.exports = {"playIcon":"PlayIcon_playIcon__KHqdF","rightTriangle":"PlayIcon_rightTriangle__mH1bA","circle":"PlayIcon_circle__rkWtc"};